// import { SCREENER_CHAINS } from "@constants/screener-chains";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import clsx from "clsx";
import { Link, useLocation } from "react-router";

const navigationItems = [
  { title: "Wallet Database", href: "/admin/wallet-screener", enabled: true },

  {
    title: "X Database",
    href: "/xdatabase",
    enabled: true,
  },
];

const NavigationItems = () => {
  const { pathname } = useLocation();
  const pathnameWithoutSlash = `/${pathname.split("/").at(1)}`;

  return navigationItems.map(({ title, href, enabled }) => (
    <Link key={href} to={href}>
      {pathnameWithoutSlash === href ? (
        <GradientBorderRadius radius="bigger" gradient="50" hover="r-100">
          <button
            className={clsx(
              "w-[9.3750rem] h-[1.8750rem] rounded-3xl dark:text-white font-semibold text-xs leading-[1.1250rem] disabled:cursor-not-allowed disabled:opacity-20",
              pathnameWithoutSlash === href &&
                "bg-gradient-to-r from-aqua/25 to-blue/25",
            )}
            disabled={!enabled}
          >
            {title}
          </button>
        </GradientBorderRadius>
      ) : (
        <GradientBorderRadius hover="r-100" radius="bigger" gradient="none">
          <button
            className={clsx(
              "w-[9.3750rem] h-[1.8750rem] rounded-3xl dark:text-white font-semibold text-xs leading-[1.1250rem] disabled:cursor-not-allowed disabled:opacity-20",
              pathnameWithoutSlash === href &&
                "bg-gradient-to-r from-aqua/25 to-blue/25",
            )}
            disabled={!enabled}
          >
            {title}
          </button>
        </GradientBorderRadius>
      )}
    </Link>
  ));
};

export default NavigationItems;
